<label [id]="idLabel" [for]="idField" [ngClass]="{'is-required': required}">
  @if (labelIcon) {
    <sd-icon [name]="labelIcon" />
  }
  <sd-html [html]="labelTitle" tag="span" />
</label>
